/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: '主页',
	myContent: '我的内容',
	teamContent: '团队内容',
	folder: '文件夹',
	files: '文件',
	actionMenu: '“操作”菜单',
	myFolder: '我的文件夹',

	emptyFolderNoContent: '无内容',

	//EmptyStates
	emptyRecentTitle: '您最近没有查看过任何内容。',
	emptyStateTitle: '首先添加数据',
	emptyStateBody: '单击上方的“上载数据”，或拖放来上载数据。',
	emptySearchResultTitle: '您的搜索未返回任何结果。',
	emptyPortalTitle: '没有门户网站',
	emptyPortalBody: '您当前没有任何门户网站。',
	emptyWsProjectTitle: '首先在 Watson Studio 中创建笔记本。',
	emptyWsProjectBody: '返回到 Cognos Analytics 时，笔记本会显示在此处。',
	emptyFilteredResultTitle: '应用的过滤器未返回任何结果。',
	emptyDialogViewTitle: '没有项',
	removeFromRecents: '从最近项中除去',

	// Welcome Banner
	welcomeBannerGreeting: '您好。欢迎使用 Cognos Analytics。',
	welcomeBannerDescription: 'Cognos Analytics 授权用户使用 AI 驱动的自助服务分析。查看自动化数据准备、数据发现和可视化如何驱动更多机密决策。',
	welcomeBannerDescription_trialUser: '通过查看简介视频、产品教程和“入门”选项卡，可以立即熟悉入门。',
	takeTourButtonLabel: '查看产品教程',
	watchVideoButtonLabel: '观看视频',
	// confirmation dialog
	hideWelcomeBannerMsg: '确定要关闭主页中的欢迎条幅吗？您可以随时在“概要文件和设置 > 设置 > 常规”中返回到此欢迎条幅。',
	hideWelcomeBannerTitle: '关闭欢迎条幅',
	ok: '确定',
	cancel: '取消',
	//howto video dialog
	modal_how_title: '如何录制视频',
	modal_overview_title: '观看 Cognos Analytics 概述',
	modal_how_play: '播放视频',
	modal_how_video_title_overview: '概述',
	modal_how_video_title_getStarted: '11.2 中的使用入门',
	modal_how_video_title_newUI: '欢迎使用新的 Cognos 体验',
	modal_how_video_title_dataModule: '数据模块概述',
	modal_how_video_title_explore: '数据浏览概述',
	modal_how_video_title_dashboard: '交互式仪表板概述',
	modal_how_video_title_reporting: '报告概述',
	modal_how_video_title_mobile: '掌控 Cognos 的功能',

	// Toolbar
	search: '搜索',
	addFolder: '添加文件夹',
	addLink: '添加链接',
	filter: '过滤器',
	sort: '排序',
	settings: '设置',
	tilesView: '磁贴视图',
	listView: '列表视图',
	columnView: '列视图',

	// Toolbar Actions
	sortBy: '排序依据',
	sortOrder: '排序',
	name: '名称',
	modifiedTime: '修改时间',
	type: '类型',
	ascending: '升序',
	descending: '降序',

	filterType: '类型',
	filterModificationTime: '修改时间',
	all: '全部',
	today: '今天',
	yesterday: '昨天',
	pastWeek: '上一周',
	pastMonth: '上个月',
	resetFilters: '重置过滤器',

	filterSearchPlaceHolder: '按关键字过滤',

	resetFilterTag: '单击 X 以重置过滤器。',
	filterTagToolTip: '应用的过滤器：%{appliedFilters}。',

	folderName: '文件夹名称',
	addAFolder: '添加文件夹',
	add: '添加',
	error: '错误',
	newFolderDefaultName: '新建文件夹',
	toastCreateNewFolder: '%{nameOfFolder} 文件夹是在 %{tabName} 中创建的。',
	folderAdded: '已添加文件夹',
	refresh: '刷新',
	openFolder: '打开文件夹',

	addAUrl: '添加 URL',
	linkName: 'URL 名称',
	linkNamePlaceholder: '添加 URL 名称',
	linkDescription: '描述（可选）',
	linkDescriptionPlaceholder: '添加描述',
	linkUri: 'URL',
	linkUriPlaceholder: '添加使用可接受域的 URL',
	acceptableDomains: '可接受的域',
	viewAcceptableDomains: '查看可接受的域',
	mandatoryField: '必填字段',
	linkAdded: '已添加 URL',
	toastCreateNewLink: '%{nameOfLink} 已添加到 %{tabName} 中。',
	noEntries: '在可接受的域列表中没有任何条目。请与您的管理员联系。',

	compact: '压缩',
	short: '短',
	default: '默认',
	rowSize: '行大小',

	// GroupyByTypes
	folders: '文件夹',
	reports: '报表',
	dashboards: '仪表板',
	data: '数据',
	packages: '数据包',
	explorations: '探索',
	stories: '案例',
	notebooks: '笔记本',
	others: '其他',

	// Error Messages
	itemsOverLimit: '指定的名称“%{itemName}”已超过最大 (20) 限制。请指定其他名称以继续。',
	errorMessageLengthFolderName: '请输入不超过 255 个字符的文件夹名称。',
	errorMessageLengthLinkName: '请输入不超过 255 个字符的链接名称。',
	toastLaunchPerspectiveError: '无法打开 %{objectType}。',
	errorNoAccessTitle: '似乎您无权访问此内容',
	errorNoAccessBody: '请与管理员联系或引用以下链接：',
	errorEnableExternalContent: '正在启用外部内容',

	//TableHeader
	lastModified: '上次修改时间',
	location: '位置',
	tenant: '租户',

	// GetStartedTab
	getStartedLabel: '快速入门并熟悉运用 IBM Cognos Analytics',
	learningHowToLabel: '学习资源',
	learningHowToDescription: '通过与社区连接、阅读文档和观看视频来扩展知识并获取帮助。',
	learningHowToActionLabel: '启动学习窗格',
	howToVideosLabel: '教程视频',
	howToVideosDescription: '了解如何使用 IBM Cognos Analytics 并开始获取对数据的洞察。',
	howToVideosActionLabel: '观看视频',
	acceleratorCatalogLabel: '加速器目录',
	acceleratorCatalogDescription: '浏览增加的行业用途的目录、最佳实践指南、自定义可视化以及更多内容。',
	acceleratorCatalogActionLabel: '浏览目录',
	sampleSectionTitle: '示样',
	sampleSectionDescription: '使用显示 Cognos Analytics 必须提供的所有示例进行试验。',
	// Samples Section
	createDashboardSampleTitle: '如何创建您的首个仪表板',
	createDashboardSampleDescription: '使用 Cognos 仪表板开始您的分析教程。',
	covid19SampleTitle: '“新型冠状病毒”仪表板',
	covid19SampleDescription: '通过用于分析新型冠状病毒肺炎 (COVID-19) 相关数据的此 Cognos Dashboard 以及定制扩展，探索各种可能的使用方法。',
	sankeySampleTitle: '桑基图',
	sankeySampleDescription: '使用自定义可视化（如桑基图）来扩展可视化库。',
	viewAllSamplesActionLabel: '查看所有示样',
	byFeatureTitle: '按功能',
	byFeatureDescription: '按功能浏览样本，如核心功能、定制控件、扩展名、笔记本以及相关日期。',
	byIndustryTitle: '按行业',
	byIndustryDescription: '按行业浏览样本，如汽车、银行等。',
	// SamplesTab
	sampleTabTitle: '使用预建示样汲取灵感',
	sampleTabLabel: '访问“加速器目录”以从 IBM、合作伙伴和客户获取更多示样和扩展',

	// quickLaunch
	quickLaunchLabel: '快速启动',
	expand: '展开',
	collapse: '折叠',

	// quickLaunch dialog
	quickLaunchModalLabel: '首先选择您要创建的内容。',

	// contentPageView
	contentPageTitleLabel: '内容',
	uploadFile: '上载数据',
	new: '新建',
	create: '创建',
	more: '更多',

	// open dialog
	selectDataSourcesToAdd: '选择要添加的数据源。',
	openDialogDefaultTitle: '打开',

	// save dialog
	save: '保存',
	saveAs: '另存为',
	saving: '正在保存...',
	selectedDestination: '所选目标：%{nameOfFolder}',
	toastDuplicateFileDifferentType: '“%{nameOfItem}”已存在，但类型不同。请选择其他名称。',
	confirmOverwriteTitle: '确认替换现有数据',
	confirmOverwriteMsg: '文件“%{nameOfFile}”已存在。是否要将其数据替换为所选文件中包含的数据？',

	// copy move dialog
	copy: '复制',
	move: '移动',
	copyOrMove: '复制或移动： ',
	copyOnly: '复制',
	createShortcut: '创建快捷方式',
	createShortcutDialogTitle: '创建快捷方式：',

	// External asset types
	wsProject: 'Watson Studio 项目',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: '数据包',
	dataModule: '数据模块',
	exploration: '探索',
	mode: '方式',
	live: '动态',
	snapshot: '快照',
	noSnapshotsFound: '找不到快照',
	uploadedFile: '已上载文件',
	fileUpload: '上载数据',
	dataSetEx: '数据集',
	externalRepository: '外部存储库',
	queryMode: '查询方式',
	queryModeCompatible: '兼容',
	queryModeDynamic: '动态',
	report: '报表',
	activeReport: '活动报表',
	query: '查询',
	analysis: '分析',
	dashboard: '仪表板',
	dashboardTemplate: '仪表板模板',
	jupyterNotebook: '笔记本',
	wsNotebook: 'Watson Studio 笔记本',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: '案例',
	workspace: '工作空间',
	pagelet: '页面',
	content: '内容',
	directory: '名称空间',
	dataSet: '数据集',
	powerPlayCube: 'PowerPlay 多维数据集',
	powerPlayReport: 'PowerPlay 报表',
	powerPlay8Report: 'PowerPlay 报表',
	powerPlay8ReportView: 'PowerPlay 报表视图',
	reportTemplate: '报表模板',
	packageConfigurations: '数据包配置',
	agent: '代理程序',
	agentDefinition: '代理程序定义',
	agentDefinitionView: '代理程序视图',
	dataMovementTask: '数据移动任务',
	dataMovementTaskAlias: '数据移动任务别名',
	document: '文档',
	DocumentRetention: '文档属性',
	jobDefinition: '作业定义',
	job: '作业',
	metricsDataSourceETLTask: '度量标准数据源 ETL 任务',
	metricsExportTask: '度量标准导出任务',
	metricsFileImportTask: '度量标准文件导入任务',
	metricsMaintenanceTask: '度量标准维护任务',
	planningTask: '正在计划任务',
	shortcut: '快捷方式',
	URL: 'URL',
	launchable: '可启动',
	dataSetFolder: '数据集文件夹',
	ViewAccessibleLabel: '查看 %{label}',
	overrideReportOptions: '覆盖默认报表选项',
	formats: '格式',
	saveReport: '保存报表',
	promptForValues: '提示我',
	reportView: '报表视图',
	html: 'html',
	pdf: 'pdf',
	spreadsheetML: 'Excel',
	xlsxData: 'Excel 数据',
	csv: 'csv',
	xml: 'xml',
	txt: 'txt',
	//Details
	details: '详细信息',
	open: '打开',
	created: '已创建',
	modified: '修改时间',
	owner: '所有者',
	dataSource: '数据源',
	share: '共享',
	addToFavorites: '添加到收藏夹',
	properties: '属性',
	detailsEmptyStateBody: '选择项以查看其详细信息',
	editNameAndDescription: '编辑名称和描述',
	none: '无',

	//rename dialog
	nameInvalid: '名称无效',
	namePlaceholder: '输入名称',
	description: '说明',
	descriptionInvalid: '说明不能超过 350 个字符。',
	descriptionPlaceholder: '输入描述',
	errorMessageApostropheError: '请输入不包含 \' 和 " 字符的文件名',
	renameCollisionError: '%{name} 已存在。请尝试其他名称。',
	unknownRenameError: '重命名项失败。请与您的管理员联系以获取进一步帮助。',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: '无法打开指定文件夹。',

	//Upload
	uploadToFolder: "上载至 <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction}",
	uploadAndLaunch: "上载至 <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> 并启动 %{launchAction}",
	quickUpload: "快速上载",
	quickUploadAndLaunch: "拖放文件以上载至 <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>，并在以下空间打开其中一个文件。",
	unsupportedFilesSingle: "未上载 %{files}，因为它对于“快速启动”无效。",
	unsupportedFilesMultiple: "文件未上载，因为您选择的所有文件必须都有效才能使用“快速启动”。",
	unsupportedFilesSingleInvalid: "%{files} 无效。",
	unsupportedFilesMultipleInvalid: "%{files} 无效。",
	supportedFileTypes: "仅允许以下文件类型：%{extensions}。",
	uploadDragAndDrop: "拖放",
	uploadDragAndDropMessage: "将文件拖放到此处以将其上载至 <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>",

	// searchBar
	searchWasSaved: '已保存搜索条件“%{searchTerm}”。',
	searchWasntSaved: '未保存搜索条件“%{searchTerm}”。',
	searchSuggestions: '建议',
	savedSearch: '已保存搜索',
	searchWasDeleted: '已删除搜索条件“%{searchTerm}”。',
	searchWasntDeleted: '未删除搜索条件“%{searchTerm}”。',
	savedBarTitle: '搜索 Cognos Analytics',
	searchContentPageTitle: '搜索',
	searchContentPageTitleLabel: '正在显示“%{searchTerm}”的结果',
	showingSearchRsult: '正在显示 %{resultCount} 项',
	saveSearch: '保存搜索',
	saveTenSearches: '您可以保存 10 次搜索。',
	deleteASearch: '删除一个以保存另一个。',
	close: '关闭',

	//recent view
	recents: '最近',
	noAccessRecent: '无访问权',
	noAccessRecentMsg: '您无权访问此资产。此资产可能已禁用或已删除，或者您的许可权可能已削减。请验证资产在其预期源位置的状态。可以通过单击“确定”从最近的项中除去此资产。',
	noAccessMsg: '您无权访问此资产。此资产可能已禁用或已删除，或者您的许可权可能已削减。',

	//contextToolbar
	itemsSelected: '已选择 %{nameOfSelection} 项',
	itemSelected: '已选择 %{nameOfSelection} 项'

});